import classNames from 'classnames';
import { NextLink } from 'components/blocks/NextLink';
import { formatAgoTimestampOrString } from 'util/formatAgo';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import cellStyles from './styles.module.scss';

interface ITitleCellProps {
  title: string
  href?: string
  updatedDate?: string,
  className?: string,
  children?: React.ReactNode;
}

const TitleCell = ({
  title,
  href = '/',
  updatedDate,
  children,
  className,
}: ITitleCellProps) => {
  const { t } = useOTSTranslation('common');

  return (
    <NextLink
      href={href}
      className={classNames(className, cellStyles.titleCell)}
    >
      <span className={classNames('h4', cellStyles.h4)}>{title}</span>
      {updatedDate && (
        <time title={t('resort.skiReport.lastUpdated')}>
          {formatAgoTimestampOrString(updatedDate)}
        </time>
      )}
      { children }
    </NextLink>
  );
};

export default TitleCell;
